import React from "react";
import styled, { css } from "styled-components";
import Logo from "../assets/icon/top_logo.svg";
import DrawerImage from "../assets/icon/Drawer.svg";
import CloseDrawer from "../assets/icon/CloseDrawer.svg";
import { useMyMediaQuery } from "../hooks/useMediaQuery";
import { device } from "../styles/media-query";
import { animated, useSpring } from "react-spring";
import Drawer from "./Drawer";

const Container = styled.header`
  background: linear-gradient(180deg, #000000 0%, rgba(0, 0, 0, 0) 100%);
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100px;

  ${device.desktop} {
    padding: 25px 50px;
  }

  ${device.tablet} {
    padding: 25px 30px;
  }

  ${device.mobile} {
    padding: 25px 20px;
  }
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 50;
`;

const Circle = styled.div<{ isDrawerOpen: boolean }>`
  border-radius: 50%;
  width: 0;
  height: 0;
  
  position: fixed;
  top: 36px;
  right: 36px;
  background: #000;
  opacity: 0;
  ${({ isDrawerOpen }) =>
    isDrawerOpen &&
    css`
      width: 3000px;
      height: 3000px;
      top: -1500px;
      right: -1500px;
      opacity: 1;
    `}
  transition: all 0.1s cubic-bezier(0.000, 0.995, 0.990, 1.000);
}


`;

const LogoImg = styled.img`
  width: 22rem;
  height: 4rem;
  z-index: 50;

  ${device.mobile} {
    width: 19rem;
    height: 3rem;
  }
`;

const MenuContainer = styled.section`
  display: flex;
  align-items: center;
`;

const MenuItem = styled.a<{ active: boolean }>`
  z-index: 10;
  cursor: pointer;
  color: ${({ active }) => (active ? "#ea3d61" : "white")};
  font-weight: 600;
  margin-right: 50px;
  font-size: 1.6rem;

  &:last-child {
    margin-right: 0;
  }

  &:hover {
    color: #ea3d61;
  }

  transition: all 0.8s ease;
`;

export const Menus = ["ABOUT", "MISSION", "PORTFOLIO", "TEAM", "PARTNERS"];

interface Props {
  onClickMenu: (sectionIndex: number) => void;
  currentSection: number;
  drawerOpen: boolean;
  onClickDrawer: () => void;
}

function Header({
  onClickMenu,
  currentSection,
  drawerOpen,
  onClickDrawer,
}: Props) {
  const { isDesktop } = useMyMediaQuery();

  const iconAnimation = useSpring({
    from: {
      transform: "rotate(0deg)",
    },
    to: {
      transform: `rotate(${drawerOpen ? "180deg" : "0deg"})`,
    },
  });

  return (
    <>
      <Container>
        <LogoImg src={Logo} alt={"LOGO"} onClick={() => onClickMenu(0)} />
        {drawerOpen && (
          <Drawer
            drawerOpen={drawerOpen}
            onClickMenu={(index) => {
              onClickMenu(index + 1);
              onClickDrawer();
            }}
            currentSection={currentSection}
          />
        )}

        <MenuContainer>
          {isDesktop ? (
            Menus.map((m, index) => (
              <MenuItem
                key={index}
                onClick={() => onClickMenu(index + 1)}
                active={currentSection - 1 === index}
              >
                {m}
              </MenuItem>
            ))
          ) : (
            <>
              <animated.img
                style={{ ...iconAnimation, zIndex: 50 }}
                alt={"Drawer"}
                src={drawerOpen ? CloseDrawer : DrawerImage}
                width={36}
                height={30}
                onClick={onClickDrawer}
              />
              <Circle isDrawerOpen={drawerOpen} />
            </>
          )}
        </MenuContainer>
      </Container>
    </>
  );
}

export default Header;
